import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/core/services';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { VisitorManagementService } from '../visitor-management.service';
import { FileDoc, FileUploadService } from 'src/app/core/components';
import { GLOBAL } from 'src/app/app.globals';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { ApiCallService } from 'src/app/service/api-call.service';
import { DataShareService } from 'src/app/service/data-share.service';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EcPoliciesService } from 'src/app/contractor/ec-policies/ec-policies.service';
import { LabourProfileImageComponent } from '../../labour/labours/create-sub-labour/labour-profile-image/labour-profile-image.component';

let fileToReturn: File;
@Component({
  selector: 'app-visitor-form-modal',
  templateUrl: './visitor-form-modal.component.html',
  styleUrls: ['./visitor-form-modal.component.css']
})
export class VisitorFormModalComponent implements OnInit {
  @ViewChild('tempRef') public tempRef: any;
  @ViewChild('tempRef1') public tempRef1: any;
  @ViewChild('tempRefApproval') public tempRefApproval: any;
  @ViewChild('uploadDocumentTemplateRef') public uploadDocumentTemplateRef: any;
  @ViewChild('registerface') public registerface: any;
  @ViewChild('video') videoElement: ElementRef;
  @ViewChild('signature') public signature: ElementRef<any>;

  userId = localStorage.getItem('UserID');
  otp: any;
  hideUpdateiteams: boolean = true
  private onDestroy: Subject<any>;

  createFormGroup(fields: string[], requiredFields: string[] = []): FormGroup {
    const group: any = {};
    fields.forEach(field => {
      group[field] = new FormControl(null, requiredFields.includes(field) ? Validators.required : null);
    });
    return new FormGroup(group);
  }

  visitorForm = this.createFormGroup([
    "Company_Code", "Plant_Code", "Unit_Code", "Department_Code", "yourcompany", "name", "jobtitle",
    "mobileno", "pgender", "emailid", "otp", "emergencycontactname", "emergencycontactno",
    "address", "address1", "zipcode", "PCountry_Code", "PState_Code", "PDistrict_Code",
    "PCity_Code", "PPostOffice_Code", "visitorcategoryasterList_Code",
    "TypeOfIdentityMasterItem_Code", "addharNo", "drvingLicense", "electionCard",
    "breanginglaptop1", "date", "starttime", "Enddate", "endtime", "actualdate",
    "actualtime", "temp", "totannumber", "lockernumber", "visitorpurposeMasterList_Code",
    "purposeofvisit1", "mobileallowed", "havematchbox", "laptopallowed", "havetoolkit",
    "name1", "identitytype", "mobilenumber", "pemailid", "pjobtitle", "Gender", "ptemp",
    "iteamtype", "iteamdescription", "serialno", "isreturnable"
  ], [
    "Company_Code", "Plant_Code", "yourcompany", "name", "jobtitle", "mobileno", "emailid",
    "otp", "emergencycontactname", "emergencycontactno", "address", "address1", "zipcode",
    "visitorcategoryasterList_Code"
  ]);

  employeeDetailForm = this.createFormGroup(["searchedKeyword"]);
  approvalForm = this.createFormGroup(["statusMasterItem_Code", "acceptingorrejectingremark", "instructiontoreception", "allwedlaptop", "allwedmobile"]);
  docForm = new FormGroup({});

  public datePickerPickerMode: string;
  public datePickerPlaceHolder: string;
  public companyData: any[] = [];
  public plants: any[] = [];
  public units: any[] = [];
  pcountries = [];
  visitorpurposetypeList: any;
  iteamtypes: any;
  genderTypes: any;
  pStates = [];
  pDistricts = [];
  pCities = [];
  pPos = [];
  pVillages = [];
  lVillages = [];
  editipersonIndex = -1;
  public activeref: any;
  hideUpdateOtherPerson = true;
  OtherPersonDetailViews = [];
  teashow = false;
  show = false;
  editshiftCode1: string;
  optionsChecked = [];
  iteamsViews = [];
  photopath: any;
  uploadedPhoto: FileDoc[] = [];
  uploadedFiles: FileDoc[] = [];
  public modalRef: any;
  allData: any;
  croppedImage: any = '';
  savedCroppedImage: any = '';
  imageChangedEvent: any = '';
  photoname: any;
  showCropper = false;
  savedSignatueImage: any = '';
  signaturePadConfigration: any = {
    png: true,
    svg: true,
    jpg: true,
    undo: true
  }
  printBtn = false
  copyUploadedFiles: FileDoc[] = [];
  documentTypes: any;
  files: any;
  visitorcategory: any[] = [];
  identityTypes: any[] = [];

  constructor(private sharedService: SharedService,
    public sharedDataService: SharedDataService,
    private modalService: NgbModal,
    private dataShareService: DataShareService,
    private cdRef: ChangeDetectorRef,
    private ecpolicyService: EcPoliciesService,
    private service: VisitorManagementService,
    private fileUploadService: FileUploadService,
    private logHelperService: LogHelperService,
    public activeModal: NgbActiveModal,
    public apiCall: ApiCallService,
    private formBuilder: FormBuilder
  ) {
    this.datePickerPlaceHolder = this.sharedService.datePickerSettings.placeHolder;
    this.datePickerPickerMode = this.sharedService.datePickerSettings.pickerMode;
    this.onDestroy = new Subject();
    this.getDocumentTypes()
  }

  ngOnInit() {
    this.files = [];
    this.getCompanyData();
    this.getPlants();
    this.getUnits();
    this.getCountry();
    this.getVisitorCategory();
    this.identityProof();
    this.visitorpurposetypeList = this.dataShareService.masterDataArrayDataShareService.filter(list => list.Parent_Code === 1073);
    this.iteamtypes = this.dataShareService.masterDataArrayDataShareService.filter(list => list.Parent_Code === 1079);
    this.genderTypes = this.dataShareService.masterDataArrayDataShareService.filter(list => list.Parent_Code === 302);
    
    // Add validators for mobile and emergency contact
    this.visitorForm.get('mobileno').setValidators([Validators.required, Validators.pattern(/^[0-9]{10}$/)]);
    this.visitorForm.get('emergencycontactno').setValidators([Validators.required, Validators.pattern(/^[0-9]{10}$/)]);
    this.visitorForm.get('emailid').setValidators([Validators.required, Validators.email]);
    
    // Add search functionality
    this.employeeDetailForm.get('searchedKeyword').valueChanges.subscribe(value => {
      this.filterEmployees(value);
    });
  }

  onChangeZipCode(zipcode) {
    if (zipcode.length === 6 && /^\d{6}$/.test(zipcode)) {
      this.getDetailsByZipCode(zipcode);
    } else {
      console.error('Invalid Zipcode:', zipcode);
    }
  }

  onChangeOTP(OTP) {
    if (OTP.length === 6 && /^\d{6}$/.test(OTP)) {
      this.OTPVerification(OTP);
    } else {
      console.error('Invalid OTP:', OTP);
    }
  }

  onChangeOtpIsValidate(Otp) {
    if (Otp.length === 6 && /^\d{6}$/.test(Otp)) {
      this.OTPVerification(Otp);
    } else {
      console.error('Invalid Otp:', Otp);
    }
  }

  getDocumentTypes() {
    // this.startCamera();
        const res = {
              "Page_Code": 424,
              "RequireType": 1,
              "ActionType": 0,
              "SelectedField": "Name,DocumentType_Code,page_code,IsMandatory,IsAuthorized,IsBeforeApproval,UpdatedBy_RoleCode",
              "Search": null,
              "UserId": this.userId
            }
            this.ecpolicyService.getDocumentTypesPageModuleWise(res).pipe(takeUntil(this.onDestroy)).subscribe((docTypes: any[]) => {
              this.documentTypes = docTypes.map((doc) => ({ ...doc }));
            });
  }

  closeModal() {
    this.activeModal.dismiss('close');
  }

  getCompanyData() {
    return this.service.getCompanyMasterData().subscribe((response: any) => {

      this.companyData = response;
      if (this.companyData.length === 1) {
        this.visitorForm.controls['Company_Code'].setValue(this.companyData[0].Company_Code);

      } else {
        this.companyData = response;
      }
    });
  }

  getPlants() {
    return this.service.getPlantMasterData().subscribe((response: any) => {
      this.plants = response;
      if (this.plants.length === 1) {
        this.visitorForm.controls['Plant_Code'].setValue(this.plants[0].Plant_Code);
      } else {
        this.plants = response;
      }
    });
  }

  getUnits() {
    return this.service.getUnitMasterData(this.visitorForm.controls['Plant_Code'].value || 100).subscribe((res: any) => {
      this.units = res.Data.Table;
      if (this.units.length === 1) {
        this.visitorForm.controls['Unit_Code'].setValue(this.units[0].Unit_Code);
      } else {
        this.units = res.Data.Table;
      }
    });
  }

  selectedPlant: any
  onChangePlant(selectedPlant: any) {
    this.selectedPlant = selectedPlant

  }
  getCountry() {
    return this.service.getCountry().subscribe((response: any) => {
      this.pcountries = response;
    });
  }

  getStatesByCountryIdP() {
    return this.service.getStatesByCountryId(this.visitorForm.controls['PCountry_Code'].value || 100)
      .subscribe((response: any) => {
        this.pStates = response;
      });
  }

  getDetailsByZipCode(zipCode: string) {
    const reqObj = {
      Filter: {
        ZipCode: zipCode,
        Search: null,
        RequiredFields: null,
        RequireType: 0,
        ActionType: 0,
        UserID: this.userId
      },
      Fields: [
        { keyName: 'Country_Code', DisplayName: 'Country' },
        { keyName: 'State_Code', DisplayName: 'State' },
        { keyName: 'District_Code', DisplayName: 'District' },
        { keyName: 'City_Code', DisplayName: 'City' },
        {
          keyName: 'PostOffice_Code',
          DisplayName: 'Village',
          ExtraFields: ['Pincode_Code', 'ZipCode']
        }
      ]
    };

    this.service.getZipCodesByData(reqObj).subscribe((response: any) => {
      if (response) {
        const country = response[0]
        const state = country.Values[0]
        const district = state.Values[0]
        const city = district.Values[0]
        const postOffice = city.Values[0]

        this.visitorForm.patchValue({
          PCountry_Code: country.Country_Code,
          PState_Code: state.State_Code,
          PDistrict_Code: district.District_Code,
          PCity_Code: city.City_Code,
          PPostOffice_Code: postOffice.PostOffice_Code,
        });

        this.pcountries = [{ Country_Code: country.Country_Code, Name: country.Country }];
        this.pStates = [{ State_Code: state.State_Code, StateName: state.State }];
        this.pDistricts = [{ District_Code: district.District_Code, DistrictName: district.District }];
        this.pCities = [{ City_Code: city.City_Code, Name: city.City }];
        this.pPos = [{ PostOffice_Code: postOffice.PostOffice_Code, PostOfficeName: postOffice.Village }];
      }
    });
  }

  getDistrictsByStateP() {
    this.service.getDistrictsByState(this.visitorForm.controls['PState_Code'].value || 100).subscribe((response: any) => {
      this.pDistricts = response;
    });
  }

  getCitiesByDistrictP() {
    this.service.getCitiesByDistrict(this.visitorForm.controls['PDistrict_Code'].value || 100).subscribe((response: any) => {
      this.pCities = response;
    });
  }
  getPostOfficeByCityP() {
    this.service.getPOsByCity(this.visitorForm.controls['PCity_Code'].value || 100).subscribe((res: any) => {
      this.pPos = res;
    });
  }

  getVisitorCategory() {
    const reqObj: any = {
      ShortCode: null,
      Search: null,
      Parent_Code: 1065,
      Page_Code: 424,
      RequireType: 2,
      ActionType: 0,
      UserId: this.userId
    }

    this.service.visitorCategorys(reqObj).subscribe((response: any) => {
      this.visitorcategory = response;
    });
  }


  identityProof() {
    const reqObj: any = {
      ShortCode: null,
      Search: null,
      Parent_Code: 575,
      Page_Code: 424,
      RequireType: 2,
      ActionType: 0,
      UserId: this.userId
    }
    this.service.getIdentityProof(reqObj).subscribe((response: any) => {
      this.identityTypes = response;
    });
  }

  getVillageP() {
    this.service.getVillageByPostOffice(this.visitorForm.controls['PPostOffice_Code'].value || 100).subscribe((response: any) => {
      this.lVillages = response.Data.Table;
    });
  }

  changeIdentitytype() {
    const typeValue = this.visitorForm.controls['TypeOfIdentityMasterItem_Code'].value;
    if (typeValue === 576) { // Aadhar Card
      this.show = true;
      this.showdrivinglicence = false;
      this.showelectioncard = false;
    } else if (typeValue === 577) { // Driving License
      this.showdrivinglicence = true;
      this.show = false;
      this.showelectioncard = false;
    } else if (typeValue === 578) { // Election Card
      this.showelectioncard = true;
      this.showdrivinglicence = false;
      this.show = false;
    }
  }

  showdrivinglicence = false;
  showelectioncard = false;
  public onvisitordetail(): void {
    this.clearData();
    this.activeModal.dismiss('close');
  }

  generateOTP() {
    const reqObj: any = {
      MobileNo: this.visitorForm.controls['mobileno'].value,
      EmailID: null,
      Referance_Code: null,
      Page_Code: 424,
      ActionType: 0,
      RequirType: 0,
      UserId: this.userId
    }

    this.service.getOTP(reqObj).subscribe((response: any) => {
      this.visitorForm.patchValue({
        otp: response[0].OTP
      });
      this.otp = response[0].OTP;
      this.OTPVerification(response[0].OTP);
    });
  }

  OTPVerification(value: any) {
    const reqObj: any = {
      MobileNo: this.visitorForm.controls['mobileno'].value,
      EmailID: null,
      Page_Code: 424,
      OTP: value
    }

    this.service.getOTPVerification(reqObj).subscribe((response: any) => {
      if (response[0].Success == "Mobile Number Verified") {
        const otpControl = this.visitorForm.get('otp');
        otpControl.clearValidators();
        otpControl.updateValueAndValidity();
      }
    });
  }

  AddIteams() {
    let formData = this.visitorForm.value;

    if (!formData.iteamtype || !formData.iteamdescription || !formData.serialno || formData.isreturnable === undefined) {
      this.logHelperService.logError({
        message: 'Please Fill Item Type , Item Description , Serial No'
      });
      return;
    }

    this.iteamtypes.forEach((result) => {
      if (result.MasterItem_Code == formData.iteamtype) {
        let reqObj = {
          ID: null,
          Visitor_Code: null,
          CreatedBy: GLOBAL.USER_ID,
          ModifiedBy: GLOBAL.USER_ID,
          ItemTypeMasterItem_Code: formData.iteamtype,
          ItemTypeMasterItem_Name: result.Name,
          ItemDescription: formData.iteamdescription,
          SerialNo: formData.serialno,
          isreturnable: formData.isreturnable !== undefined ? formData.isreturnable : false,
          isReturnableValue: formData.isreturnable !== undefined ? 0 : 1
        };
        this.iteamsViews.push(reqObj);
        this.visitorForm.patchValue({
          iteamtype: null,
          iteamdescription: null,
          serialno: null,
          isreturnable: null,
        });
      }
    });
  }

  editIndex: number = -1;

  edititeams(index: number) {
    if (index < 0 || index >= this.iteamsViews.length) return;

    this.hideUpdateiteams = false;
    this.editIndex = index;

    let result = this.iteamsViews[index];

    this.visitorForm.patchValue({
      iteamtype: result.ItemTypeMasterItem_Code,
      iteamdescription: result.ItemDescription,
      serialno: result.SerialNo,
      isreturnable: Boolean(result.isreturnable)
    });
  }

  updateiteams() {
    if (this.editIndex < 0) {
      return;
    }

    const formData = this.visitorForm.value;

    if (!formData.iteamtype || !formData.iteamdescription || !formData.serialno || formData.isreturnable === undefined) {
      this.logHelperService.logError({
        message: 'Please Fill Item Type, Item Description, and Serial No'
      });
      return;
    }

    this.iteamtypes.forEach((result) => {
      if (result.MasterItem_Code == formData.iteamtype) {
        let updatedItem = {
          ID: this.iteamsViews[this.editIndex].ID || null, // Preserve ID if exists
          Visitor_Code: null,
          CreatedBy: GLOBAL.USER_ID,
          ModifiedBy: GLOBAL.USER_ID,
          ItemTypeMasterItem_Code: formData.iteamtype,
          ItemTypeMasterItem_Name: result.Name,
          ItemDescription: formData.iteamdescription,
          SerialNo: formData.serialno,
          isreturnable: formData.isreturnable !== undefined ? formData.isreturnable : false,
          isReturnableValue: formData.isreturnable !== undefined ? 0 : 1
        };

        this.iteamsViews[this.editIndex] = updatedItem;
        this.visitorForm.patchValue({
          iteamtype: null,
          iteamdescription: null,
          serialno: null,
          isreturnable: null,
        });
        this.editIndex = -1;
        this.hideUpdateiteams = true;
      }
    });
  }

  deleteiteams(index: number) {
    if (index < 0 || index >= this.iteamsViews.length) return;

    this.iteamsViews.splice(index, 1);
    this.hideUpdateiteams = true;
  }


  // tslint:disable-next-line: function-name
  AddOtherPersonDetail(index?: number) {

    // tslint:disable-next-line: max-line-length
    if (this.visitorForm.controls.name1.value != null && this.visitorForm.controls.Gender.value != null && this.visitorForm.controls.pjobtitle.value != null) {
      if (typeof index !== 'undefined') {
        this.OtherPersonDetailViews[index] = {
          Name: this.visitorForm.controls.name1.value,
          pjobtitle: this.visitorForm.controls.pjobtitle.value,
          mobilenumber: this.visitorForm.controls.mobilenumber.value,
          Gender: this.visitorForm.controls.Gender.value,
          ptemp: this.visitorForm.controls.ptemp.value,
        };
        this.visitorForm.controls['name1'].reset();
        this.visitorForm.controls['pjobtitle'].reset();
        this.visitorForm.controls['mobilenumber'].reset();
        this.visitorForm.controls['Gender'].reset();
        this.visitorForm.controls['ptemp'].reset();

      } else {
        this.OtherPersonDetailViews.push({
          Name: this.visitorForm.controls.name1.value,
          JobTitle: this.visitorForm.controls.pjobtitle.value,
          MobileNo: this.visitorForm.controls.mobilenumber.value,
          GenderMasterItem_Code: this.visitorForm.controls.Gender.value,
          Temperature: this.visitorForm.controls.ptemp.value,
          EmailID: this.visitorForm.controls.pemailid.value,
          IdentityType_Code: this.visitorForm.controls.identitytype.value,

        });
        this.visitorForm.controls['name1'].reset();
        this.visitorForm.controls['pjobtitle'].reset();
        this.visitorForm.controls['mobilenumber'].reset();
        this.visitorForm.controls['Gender'].reset();
        this.visitorForm.controls['ptemp'].reset();
        this.visitorForm.controls['pemailid'].reset();
        this.visitorForm.controls['identitytype'].reset();
      }
    } else {
      this.logHelperService.logError({
        message: 'Please Fill Name , JobTitle , Gender First'
      });
    }
    return;
  }
  editiperson(index) {
    this.editipersonIndex = index;
    this.hideUpdateOtherPerson = false;
    this.visitorForm.controls['name1'].setValue(this.OtherPersonDetailViews[index].Name);
    this.visitorForm.controls['pjobtitle'].setValue(this.OtherPersonDetailViews[index].JobTitle);
    this.visitorForm.controls['mobilenumber'].setValue(this.OtherPersonDetailViews[index].MobileNo);
    this.visitorForm.controls['Gender'].setValue(this.OtherPersonDetailViews[index].GenderMasterItem_Code);
    this.visitorForm.controls['ptemp'].setValue(this.OtherPersonDetailViews[index].Temperature);
    this.visitorForm.controls['pemailid'].setValue(this.OtherPersonDetailViews[index].EmailID);
    this.visitorForm.controls['identitytype'].setValue(this.OtherPersonDetailViews[index].IdentityType_Code);
  }
  updateiPersonDetail() {
    this.AddOtherPersonDetail(this.editipersonIndex);
  }
  deleteperson(index) {
    this.OtherPersonDetailViews.splice(index, 1);
    this.hideUpdateOtherPerson = true;
  }

  private clearData() {
    this.visitorForm.reset();
    this.employeeDetailForm.reset();
    this.approvalForm.reset();

    this.teashow = false;
    this.show = false;
  }
  private formatDate(dateValue: any): string {
    if (!dateValue) return null;
    if (typeof dateValue === 'string') return dateValue;
    if (dateValue._isAMomentObject) {
      return dateValue.format('YYYY-MM-DD');
    }
    return new Date(dateValue).toISOString().split('T')[0];
  }

  private formatTime(timeValue: any): string {
    if (!timeValue) return null;
    if (typeof timeValue === 'string') {
      // If it's already a time string, return as is
      if (timeValue.match(/^\d{2}:\d{2}(:\d{2})?$/)) {
        return timeValue;
      }
    }
    if (timeValue._isAMomentObject) {
      return timeValue.format('HH:mm:ss');
    }
    // Handle Date objects - extract only time portion
    const date = new Date(timeValue);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  private parseTemperature(tempValue: any): string {
    if (!tempValue) return '0';
    if (typeof tempValue === 'number') return tempValue.toString();
    if (typeof tempValue === 'string') {
      const parsed = parseFloat(tempValue);
      return isNaN(parsed) ? '0' : parsed.toString();
    }
    return '0';
  }

  public SubmitRequest(): void {
    const value = this.visitorForm.getRawValue();

    Object.keys(this.visitorForm.controls).forEach(key => {
      this.visitorForm.get(key).markAsTouched();
    });
    
    if (this.visitorForm.invalid) {
      this.logHelperService.logError({
        message: 'Please fill all required fields'
      });
      return;
    }
    
    if (!value.visitorcategoryasterList_Code) {
      this.logHelperService.logError({
        message: 'Please select visitor category'
      });
      return;
    }
    
    if (!value.date) {
      this.logHelperService.logError({
        message: 'Please select start date'
      });
      return;
    }
    
    if (!value.Enddate) {
      this.logHelperService.logError({
        message: 'Please select end date'
      });
      return;
    }
    
    if (!value.actualdate) {
      this.logHelperService.logError({
        message: 'Please select actual date'
      });
      return;
    }

    if (!this.savedCroppedImage && !this.photopath) {
      this.logHelperService.logError({
        message: 'Please upload image'
      });
      return;
    }
    
    if (!this.files || this.files.length === 0) {
      this.logHelperService.logError({
        message: 'Please upload document'
      });
      return;
    }
    
    if (!this.selectedHosts || this.selectedHosts.length === 0) {
      this.logHelperService.logError({
        message: 'Please select at least one host'
      });
      return;
    }

    if (this.visitorForm.value.otp != this.otp) {
      this.logHelperService.logError({
        message: 'Invalid OTP'
      });
      return;
    }
    const filteredArray = this.iteamsViews.map(({ isreturnable, ItemTypeMasterItem_Name, ...rest }) => rest);

    const reqObj = {
      "FA3AE3BB-807F-4592-85E7-103F00D17853": [
        {
          Visitor_Code: null,
          Company_Code: value.Company_Code || 101,
          Plant_Code: value.Plant_Code || 100,
          Unit_Code: value.Unit_Code || 100,
          Department_Code: value.Department_Code || 101,
          EntryFormStatus: 0,
          VisitorCompany: value.yourcompany,
          FullName: value.name,
          GenderMAsterItem_Code: value.pgender || 319,
          JobTitle: value.jobtitle,
          MobileNo: value.mobileno,
          SmsOTP: String(value.otp) || '000',
          EmailID: value.emailid,
          EmailOTP: '000',
          EmergancyContactName: value.emergencycontactname,
          EmergancyContactNo: value.emergencycontactno,
          Address1: value.address,
          Address2: value.address1,
          ZipCode: value.zipcode,
          Country_Code: value.PCountry_Code || 100,
          State_Code: value.PState_Code || 107,
          District_Code: value.PDistrict_Code || 232,
          City_Code: value.PCity_Code || 2827,
          PostOffice_Code: value.PPostOffice_Code || 19710,
          Village_Code: 0,
          VisitorCategoryMIL_Code: value.visitorcategoryasterList_Code || 1072,
          IDProofTypeMIL_Code: value.TypeOfIdentityMasterItem_Code || 577,
          AddharNo: value.addharNo || null,
          PassportNo: null,
          ElectionCardNo: value.electionCard || null,
          DrivingLicenceNo: value.drvingLicense || null,
          StartDate: this.formatDate(value.date),
          StartTime: this.formatTime(value.starttime),
          Temperature: this.parseTemperature(value.temp),
          TokenNumber: value.totannumber || 11,
          LockerNumber: value.lockernumber || 12,
          VisitorPurposeTypeMIL_Code: value.visitorpurposeMasterList_Code || 1075,
          Visitorpurpose: value.purposeofvisit1,
          HaveMobile: value.mobileallowed ? 1 : 0,
          HaveToolkit: value.havetoolkit ? 1 : 0,
          HaveLaptop: value.laptopallowed ? 1 : 0,
          HaveMaterials: 1,
          HaveReturnableMaterials: 0,
          HaveMatchBox: value.havematchbox ? 1 : 0,
          AllowedLaptop: 0,
          AllowedMobile: 0,
          AllowedToolkit: 0,
          AllowedMaterials: 0,
          AllowedReturnableMaterials: 0,
          IsBlacklisted: 0,
          ReasonForBlacklist: 0,
          Remark: '-',
          Instruction: 'Other/Any',
          CreatedBy: 100,
          ModifiedBy: 100,
          "574CFB41-769F-4652-84D6-335AC9D25A8C": filteredArray.map(item => ({
            ID: item.ID,
            Visitor_Code: item.Visitor_Code,
            ItemTypeMIL_Code: item.ItemTypeMasterItem_Code, // Fixed field name to match backend expectation
            ItemDescription: item.ItemDescription,
            SerialNo: item.SerialNo,
            IsReturnableIteam: item.isreturnable ? 1 : 0, // Fixed field name to match backend expectation
            CreatedBy: 100,
            ModifiedBy: 100
          })),
          "0BF55340-7B38-4378-BC0D-73AD9CA06384": this.selectedHosts.map(host => ({
              Request_Code: null,
              Visitor_Code: null,
              Host_Code: host.Employee_Code || host.EmployeeCode || host.Id,
              Plant_Code: value.Plant_Code || 100,
              RequestType_Code: 111,
              RequestNo: 'xyz001',
              FirstRequestUser: this.userId,
              IsApproved: 0,
              CreatedBy: this.userId,
              ModifiedBy: this.userId,
              "3D867CB0-029A-4EF8-A71B-0E58CF686196": [
                {
                  RequestApprover_Code: null,
                  Request_Code: null,
                  RequestLevel_Code: 0,
                  StatusMasterList_Code: 637,
                  Comment: "-",
                  CreatedBy: this.userId,
                  ModifiedBy: this.userId
                }
              ]
            }))
        }
      ]
    };

    this.service.createVisitor(reqObj).subscribe(
      (response: any) => {
        const visitorCode = response.Data;
        if (visitorCode) {
          this.uploadDocuments(visitorCode);
          if (this.photopath) {
            this.fileUploadService.uploadPhoto(this.photopath, { Visitor_Code: visitorCode }, GLOBAL.APIS.VISITOR_MANAGEMENT.UPLOAD_VISITOR_PHOTO)
              .subscribe((res) => {
              }, (photoError) => {
              });
          }
          
          // Send approval email to selected hosts
          if (this.selectedHosts && this.selectedHosts.length > 0) {
            this.selectedHosts.forEach(host => {
              const hostEmail = host.EmailID || host.Email;
              if (hostEmail) {
                const emailPayload = {
                  To: hostEmail,
                  CC: null,
                  BCC: null,
                  Subject: 'Visitor Approval Request',
                  Body: `<p>Dear Sir/Madam,</p>
                         <p>This is to inform you that a visitor request has been submitted for your approval. Kindly review the details and provide your approval to proceed.</p>
                         <p><strong>Visitor Details:</strong></p>
                         <ul>
                           <li>Name: ${value.name || 'N/A'}</li>
                           <li>Company: ${value.yourcompany || 'N/A'}</li>
                           <li>Purpose of Visit: ${value.purposeofvisit1 || 'N/A'}</li>
                           <li>Date & Time: ${this.formatDate(value.date)} ${this.formatTime(value.starttime)}</li>
                           <li>Location: ${this.plants.find(p => p.Plant_Code === value.Plant_Code) ? this.plants.find(p => p.Plant_Code === value.Plant_Code).PlantName : 'N/A'}</li>
                         </ul>
                         <p>Your timely approval will help us ensure smooth coordination and entry arrangements.</p>
                         <p>Please feel free to contact us for any clarification or additional information.</p>
                         <p>Thank you for your cooperation.</p>`
                };
                
                this.apiCall.sendEmail(emailPayload).subscribe(
                  (emailRes) => {
                    console.log('Approval email sent to:', hostEmail);
                  },
                  (emailError) => {
                    console.error('Failed to send approval email:', emailError);
}
                );
              }
            });
          }
        }
        
        this.logHelperService.logSuccess({
          message: 'Visitor created successfully'
        });
        
        this.visitorForm.reset();
        this.iteamsViews = [];
        this.OtherPersonDetailViews = [];
        this.uploadedFiles = [];
        this.files = [];
        this.savedCroppedImage = '';
        this.croppedImage = '';
        this.imageChangedEvent = '';
        this.photopath = null;
        this.closeModal();
      },
      (error) => {
        this.logHelperService.logError({
          message: 'Error creating visitor (' + error.status + '): ' + (error.error && error.error.Message ? error.error.Message : (error.message || 'Unknown error'))
        });
      }
    );
  }
  
  uploadDocuments(Visitor_Code) {
    if (this.uploadedFiles.length) {
      const DocumentImageMasterViewModals: any = [];
      this.uploadedFiles.forEach((file) => {
        if (file.isUploaded) {
          DocumentImageMasterViewModals.push({
            ID: file.ID,
            DocumentTypeMasterList_Code: file.documentTypeCode,
          });
        } else {
          DocumentImageMasterViewModals.push({
            DocumentTypeMasterList_Code: file.documentTypeCode,
          });
        }
      });
    }
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      if (Visitor_Code) {
        this.fileUploadService.uploadFiles(
          this.uploadedFiles,
          Visitor_Code,
          GLOBAL.APIS.CONTRACTOR_MANAGEMENT.UPLOAD_LABOUR_DOC
        ).subscribe((res) => { });
      }
    }
  }

  allEmployeeData: any;
  filteredEmployeeData: any;
  selectedHosts: any[] = [];
  
  employeeDetail() {
    return this.service.getEmployeeDetail().subscribe((res: any) => {
      this.allEmployeeData = res;
      this.filteredEmployeeData = res;
    });
  }
  
  filterEmployees(searchTerm: string) {
    if (!this.allEmployeeData) {
      this.filteredEmployeeData = [];
      return;
    }
    if (!searchTerm) {
      this.filteredEmployeeData = this.allEmployeeData;
    } else {
      const term = searchTerm.toLowerCase();
      this.filteredEmployeeData = this.allEmployeeData.filter(emp => 
        emp.Name && emp.Name.toLowerCase().includes(term)
      );
    }
  }

  IsCheck(item: any, event: any) {
    if (event.target.checked) {
      this.selectedHosts.push(item);
    } else {
      const index = this.selectedHosts.findIndex(h => 
        (h.Employee_Code && h.Employee_Code === item.Employee_Code) ||
        (h.EmployeeCode && h.EmployeeCode === item.EmployeeCode) ||
        (h.Id && h.Id === item.Id) ||
        h.Name === item.Name
      );
      if (index > -1) {
        this.selectedHosts.splice(index, 1);
      }
    }
  }

  isHostSelected(item: any): boolean {
    return this.selectedHosts.some(h => 
      (h.Employee_Code && h.Employee_Code === item.Employee_Code) ||
      (h.EmployeeCode && h.EmployeeCode === item.EmployeeCode) ||
      (h.Id && h.Id === item.Id) ||
      h.Name === item.Name
    );
  }
  // tslint:disable-next-line: function-name
  UploadDoc(): void {

    this.modalRef = this.modalService.open(this.uploadDocumentTemplateRef,
      { size: 'lg', backdrop: 'static', keyboard: false, windowClass: 'modal-scrollbar-hide' });
  }

  TakePhoto(): void {
    this.modalRef = this.modalService.open(LabourProfileImageComponent, { size: 'lg', backdrop: 'static', windowClass: 'modal-scrollbar-hide' });
    const modalRef = this.modalRef;
    modalRef.componentInstance.croppedImage.pipe(take(1)).subscribe((image: string) => {
      if (!image) {
        return;
      }
      this.croppedImage = image;
      this.savedCroppedImage = image;
      const fileName = `visitor-photo-${Date.now()}.png`;
      this.photopath = this.base64ToFile(image, fileName);
      this.photoname = fileName;
    });
  }
  RegisterFace(): void {
    this.modalRef = this.modalService.open(this.registerface, { windowClass: 'modal-scrollbar-hide' });
  }
  Host() {
    Object.keys(this.visitorForm.controls).forEach(key => {
      this.visitorForm.get(key).markAsTouched();
    });
    
    if (this.visitorForm.invalid) {
      this.logHelperService.logError({
        message: 'Please Fill Mandatory Fields First'
      });
      return;
    }
    
    this.employeeDetail();
    this.modalRef = this.modalService.open(this.tempRef1,
      { size: 'lg', backdrop: 'static', windowClass: 'modal-scrollbar-hide' });
  }
  saveCroppedImage(type): void {
    this.savedCroppedImage = this.croppedImage;
    if (type == 'uploadDoc') {
      if (!this.files || this.files.length === 0) {
        this.files = [];
        alert("Please upload document");
        return;
      }
    } else if (type == 'capturePhoto') {
      if (!this.imageChangedEvent) {
        return alert("Please upload image")
      }
    }

    // let validDoc = false
    // for (let i = 0; i < this.files.length; i++) {
    //   if (this.files[i].documentTypeCode == 108 || this.files[i].documentTypeCode == 117) {
    //     validDoc = true
    //   }
    // }
    // if (!validDoc) {
    //   alert("Please upload valid document")
    //   return
    // }
    this.modalRef.close();
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;

    fileToReturn = this.base64ToFile(
      event.base64,
      this.imageChangedEvent.target.files[0].name,
    );
    this.photopath = fileToReturn;
    this.photoname = this.imageChangedEvent.target.files[0].name;
    return fileToReturn;
  }
  base64ToFile(data, filename) {

    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  imageLoaded() {
    this.showCropper = true;
  }
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  rotateLeft(imageCropper: ImageCropperComponent) {
    imageCropper.rotateLeft();
  }
  rotateRight(imageCropper: ImageCropperComponent) {
    imageCropper.rotateRight();
  }

  cropperReady() {}
  loadImageFailed() {}

  TakeSignature(): void {
    this.modalRef = this.modalService.open(this.signature, {
      backdrop: 'static',
      keyboard: false
    });
  }

  saveSignature(dataURL: string) {
    this.savedSignatueImage = dataURL;
    console.log('Signature saved, length:', dataURL ? dataURL.length : 0);
    this.modalRef.close();
  }

  printRequest() {
    window.print();
    // this.activeref = this.modalService.open(PrintRequestComponent, { size: 'lg', backdrop: 'static' });
  }

  onFilesChanged(newFiles: any) {
    this.files = newFiles;
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      name: '',
      description: '',
      price: ''
    });
  }

}

